module.exports = __webpack_public_path__ + "static/media/bubble-pop.b879197f.mp3";